<template>
  <div class="flex flex-wrap -mx-3 justify-center md:justify-start">
    <div
      v-for="(video, index) in videos"
      :key="index"
      class="p-3 relative"
      @click="$emit('input', video)"
    >
      <div
        v-if="value && value.id === video.id"
        class="absolute flex items-center justify-center w-6 h-6 bg-white rounded-full pin-r mr-5 pin-t border border-green"
      >
        <icon
          name="tick"
          :center="false"
          class="w-6 h-6 text-green"
        />
      </div>
      <div
        class="box border border-primary overflow-hidden"
        :class="{
          'mb-3': video.title !== undefined,
          'border-green': value && value.id === video.id,
        }"
      >
        <video
          width="160"
          height="90"
          loop
          @mouseenter="$event.target.play()"
          @mouseleave="$event.target.currentTime = 0; $event.target.pause();"
        >
          <source
            :src="video.path"
            type="video/mp4"
          >
        </video>
      </div>
      <div
        v-if="video.title"
        class="text-xs mt-1 text-center w-full uppercase"
      >
        {{ video.title }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoGridPicker',
  props: ['videos', 'value']
}
</script>

<style scoped>
.box {
  width: 160px;
  height: 90px;
}
</style>
